import { render } from "./CvSectionLoader.vue?vue&type=template&id=37c344ec&scoped=true&ts=true"
import script from "./CvSectionLoader.vue?vue&type=script&lang=ts"
export * from "./CvSectionLoader.vue?vue&type=script&lang=ts"

import "./CvSectionLoader.vue?vue&type=style&index=0&id=37c344ec&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c344ec"]])

export default __exports__